import { Random } from "@redotech/util/random";

/**
 * Cryptographically secure random generator, base on the
 * {@link https://developer.mozilla.org/en-US/docs/Web/API/Crypto Web Crypto API}.
 */
export const cryptoRandom: Random = {
  bytes(length: number): ArrayBuffer {
    return new Uint8Array(crypto.getRandomValues(new Uint8Array(length)))
      .buffer;
  },
  float(max: number): number {
    // Note: only 32-bits of randomness
    const values = new Uint32Array(1);
    crypto.getRandomValues(values);
    const result = values[0] * (max / 2 ** 32);
    return result < max ? result : 0; // in case of rounding error
  },
  integer(max: number): number {
    return Math.floor(this.float(max));
  },
};
